import React from 'react';
export function Hero() {
  return <div className="mb-8" data-id="element-92">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6 font-sans" data-id="element-93">
        I Was Terrified to Quit Drinking Because of Withdrawal—
        <span className="bg-[#FEF3C7] px-1" data-id="element-94">Until I Discovered This Patch</span>
      </h1>
    </div>;
}